import { parallel } from "async";

// moving from redux to _services
import {
  getHistogram,
  getCollabs,
  getCollabsMultiple,
  getCredentials,
  getArticles,
  getMoreArticles,
  getArticlesMultiple,
  getArticlesMultipleMore,
  getClinicalTrials,
  getGrants,
  getMoreGrants,
  getMsArticles,
  getMoreMsArticles,
  getPayments,
  getMorePayments,
  getExternalLinks,
  getPatents
} from "../../_services/application/expertBio";

// all APIs for single keyword and non-keyword
const allApis = (props) => {
  const {
    token,
    expertId,
    keyword,
    expertin,
    moduleId,
    showFullProfile,
    state,
    entities,
    filters,
    customFilters
  } = props;

  const results = parallel({
    histogram: async (callback) => {
      let data = await getHistogram(token, {
        expertId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        expertin,
        moduleId,
        showFullProfile,
        entities,
        filters
      });
      return callback(null, data);
    },
    collabs: async (callback) => {
      let collabs = await getCollabs(token, {
        expertId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        expertin,
        showFullProfile,
        moduleId,
        entities,
        filters
      });
      return callback(null, collabs);
    },
    credentials: async (callback) => {
      let credentials = await getCredentials(token, {
        expertId,
        expertin,
        keyword,
        moduleId,
        entities,
        filters,
        customFilters
      });
      return callback(null, credentials);
    },
    articles: async (callback) => {
      let articles = await getArticles(token, {
        expertId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        size: state.articles.size,
        from: state.articles.from,
        expertin,
        moduleId,
        showFullProfile,
        entities,
        filters,
        customFilters
      });
      return callback(null, articles);
    },
    trials: async (callback) => {
      let trials = await getClinicalTrials(token, {
        expertId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        moduleId,
        expertin,
        isMulti: true,
        from: state.trials.from,
        showFullProfile,
        size: state.trials.size,
        entities,
        filters
      });
      return callback(null, trials);
    },
    grants: async (callback) => {
      let grants = await getGrants(token, {
        expertId,
        moduleId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        size: 10,
        from: 0,
        entities,
        filters
      });
      return callback(null, grants);
    },
    msArticles: async (callback) => {
      let msArticles = await getMsArticles(token, {
        expertId,
        moduleId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        size: state.msArticles.size,
        from: state.msArticles.from,
        entities,
        filters
      });
      let { msArticles: articles = {} } = msArticles || {};
      return callback(null, articles);
    },
    payments: async (callback) => {
      let payments = await getPayments(token, {
        expertId,
        moduleId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        size: state.payments.size,
        from: state.payments.from,
        entities,
        showFullProfile,
        filters
      });
      return callback(null, payments);
    },
    externalLinks: async (callback) => {
      let externalLinks = await getExternalLinks(token, { expertId, moduleId });
      return callback(null, externalLinks);
    },
    patents: async (callback) => {
      let patents = await getPatents(token, {
        expertId,
        moduleId,
        keyword: showFullProfile === "yes" && keyword ? null: keyword,
        size: 10,
        from: 0,
        entities,
        filters
      });
      return callback(null, patents);
    }
  });

  return results;
};

export default allApis;
